import { render, staticRenderFns } from "./special-gifts-solution.vue?vue&type=template&id=23b81922"
import script from "./special-gifts-solution.vue?vue&type=script&lang=js"
export * from "./special-gifts-solution.vue?vue&type=script&lang=js"
import style0 from "./special-gifts-solution.vue?vue&type=style&index=0&id=23b81922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
